{
  "common.close": "Закрити",
  "common.athleteFallback": "спортсмен {id}",
  "splash.title": "{app} — анімована візуалізація активностей",
  "splash.tagline": "Ваші дані Strava&nbsp;в русі",
  "splash.demo": "Демо",
  "tab.query.title": "Карта: {name}",
  "tab.query.heading": "Запит активностей:",
  "tab.query.optDays": "останні дні",
  "tab.query.optActivities": "останні активності",
  "tab.query.optIds": "ID активностей",
  "tab.query.optDates": "Діапазон дат",
  "tab.query.idsPlaceholder": "введіть ID активностей тут",
  "tab.query.after": "Від:",
  "tab.query.before": "До:",
  "tab.query.autozoom": "Після імпорту автоматично наблизити <i class=\"hf hf-bullseye\"></i> до результатів",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Завантажити",
  "tab.query.createAccount": "Створіть обліковий запис і/або увійдіть.",
  "tab.query.sports": "Види спорту:",
  "tab.query.allSports": "Усі види спорту",
  "tab.query.sportsExcept": "Усі, крім",
  "tab.query.sportsNone": "Жодного",
  "tab.query.loadingSports": "Завантаження видів спорту…",
  "tab.query.sportsFailed": "Не вдалося завантажити види спорту цієї мапи",
  "tab.query.noSports": "Ще немає активностей",
  "tab.activities.title": "Показані активності",
  "tab.activities.clearSelection": "Скасувати вибір",
  "tab.activities.renderSelected": "Показати вибрані",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Наблизити до вибраного",
  "tab.controls.title": "Налаштування шару",
  "tab.controls.timescale": "Масштаб часу <i>&tau;</i>",
  "tab.controls.timescaleHint": "швидкість відтворення",
  "tab.controls.period": "Період <i>T</i>",
  "tab.controls.periodHint": "активність ~ модель",
  "tab.controls.dotSize": "Розмір точок",
  "tab.controls.pathWidth": "Товщина треків",
  "tab.controls.pathWidthHint": "нуль приховує треки",
  "tab.controls.colors": "Кольори",
  "tab.controls.colorsHint": "повернути палітру",
  "tab.controls.shadows": "Тіні",
  "tab.profile.loginTitle": "Увійти",
  "tab.profile.anonNote": "Увійдіть через Strava, щоб бачити свої активності й керувати обліковим записом Heatflask.",
  "tab.profile.loginLink": "Увійти через Strava",
  "tab.profile.editOnStrava": "Редагувати профіль на Strava",
  "tab.profile.indexNote": "Ми індексуємо підсумки ваших активностей для швидкого доступу.",
  "tab.profile.viewIndex": "Переглянути індекс",
  "tab.profile.sharedMaps": "Спільні карти",
  "tab.profile.sharedMapsNote": "Вимкнено: лише ви бачите свої активності в Heatflask. Увімкнено: будь-хто з посиланням на вашу карту бачить активності, які ви зробили публічними на Strava. Приватні в будь-якому разі залишаються лише вашими. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Як працює приватність</a>",
  "tab.profile.logout": "Вийти",
  "tab.profile.deleteAccount": "Видалити обліковий запис",
  "tab.profile.deleteConfirm": "Видалити ваш обліковий запис Heatflask?\n\nЦе видалить ваші проіндексовані активності та відкличе доступ Heatflask до ваших даних Strava. Цю дію неможливо скасувати.",
  "tab.profile.languageHeading": "Мова",
  "tab.profile.languageAuto": "Автоматично",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Допоможіть нам виправити переклади або додати нові!</a>",
  "tab.profile.unitsHeading": "Одиниці",
  "tab.profile.unitsAuto": "Автоматично",
  "tab.profile.unitsMetric": "Метричні (км, м)",
  "tab.profile.unitsImperial": "Імперські (mi, ft)",
  "tab.profile.textSizeHeading": "Розмір тексту",
  "tab.profile.textSmaller": "Менше",
  "tab.profile.textReset": "Звичайний",
  "tab.profile.textLarger": "Більше",
  "tab.profile.mapDefaultsHeading": "Типові налаштування карти",
  "tab.profile.mapDefaultsNote": "Починати з цієї підкладки, рельєфу та налаштувань шару, коли ви відкриваєте карту, посилання на яку не задає власних. Посилання, якими ви ділитеся, і далі показують саме те, що бачите ви.",
  "tab.profile.mapDefaultsSave": "Зберегти як мої типові",
  "tab.profile.mapDefaultsForget": "Забути",
  "tab.info.title": "Інформація",
  "tab.info.controlsHeading": "Керування",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + перетягування",
  "tab.info.shiftDragDesc": "Виділіть активності рамкою. На сенсорному екрані спершу торкніться <i class=\"hf-object-group\"></i>, а потім проведіть одним пальцем. Остання вибрана активність показує свої подробиці, а список активностей прокручується до неї.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + перетягування",
  "tab.info.ctrlDragDesc": "Обертайте й нахиляйте карту в 3D або використовуйте два пальці",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Відкрити або закрити бічну панель",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Попередня або наступна вкладка панелі",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Закрити бічну панель",
  "tab.info.liveUrlHeading": "Живий URL",
  "tab.info.liveUrlDesc": "Вигляд карти та налаштування анімації зберігаються в URL сторінки, тож кожен, з ким ви ним поділитеся, побачить те саме.",
  "tab.info.videoHeading": "Експорт відео",
  "tab.info.videoDesc": "Кнопка <i class=\"hf-video-camera\"></i> записує анімацію в MP4: торкніться її, наведіть рамку на потрібну частину карти й торкніться знову, щоб почати запис. Записується повний цикл анімації, тому відео повторюється без стику; цикл, довший за {max} с (найдовше відео, яке приймає Strava), обрізається на {max} с.",
  "tab.info.contributeHeading": "Долучитися",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Підтримати на GitHub",
  "tab.info.contactsHeading": "Контакти",
  "map.basemapAndTerrain": "Базова карта й рельєф",
  "map.pauseAnimation": "Призупинити анімацію",
  "map.resumeAnimation": "Продовжити анімацію",
  "capture.record": "Записати відео (цикл {period} с)",
  "capture.recordTruncated": "Записати відео (один цикл триває {period} с; буде записано лише перші {max} с)",
  "capture.recordArea": "Записати область у рамці",
  "capture.stop": "Зупинити запис",
  "capture.selectionTooSmall": "виділення замале",
  "capture.saved": "збережено {name} ({size})",
  "capture.cancelled": "запис скасовано",
  "capture.failed": "не вдалося записати: {error}",
  "capture.loadingEncoder": "завантаження кодера…",
  "capture.waitingForMap": "очікування завантаження карти…",
  "capture.encoding": "кодування… {percent}%",
  "capture.finalizing": "завершення…",
  "share.title": "Поділитися посиланням на цю карту",
  "share.copied": "посилання скопійовано",
  "share.copiedUnshared": "посилання скопійовано, але ваша карта не спільна, тож ніхто інший її не відкриє. Увімкніть «Спільні карти», щоб це змінити.",
  "share.unshared": "Ваша карта не спільна, тож ніхто інший не відкриє це посилання. Увімкніть «Спільні карти», щоб це змінити.",
  "share.copyThis": "Скопіюйте це посилання:",
  "update.available": "Доступна нова версія Heatflask.",
  "update.reload": "Перезавантажити",
  "import.title": "Імпорт",
  "import.stop": "Зупинити",
  "import.stopping": "зупинка…",
  "import.contacting": "з'єднання зі Strava…",
  "import.countOf": "Активності: {received} з {total}",
  "import.count": "Активності: {received}",
  "import.waitStrava": "Пауза до {time} через ліміт завантажень Strava. Не закривайте сторінку; перезавантаження не пришвидшить.",
  "import.waitRationed": "Швидкі завантаження на сьогодні вичерпано. Решта продовжиться о {time}, повільніше. Не закривайте сторінку.",
  "import.dailyLimit": "Денний ліміт завантажень Strava вичерпано. Спробуйте знову після {time}.",
  "import.dailyRationed": "Вашу частку завантажень зі Strava на сьогодні вичерпано. Спробуйте знову після {time}.",
  "import.noActivitiesYet": "У вашому обліковому записі Strava ще немає активностей. Запишіть або завантажте одну в Strava, і вона з'явиться тут.",
  "table.noActivities": "немає активностей",
  "table.untitled": "(без назви)",
  "activities.pageTitle": "{app} — Індекс активностей",
  "activities.heading": "Індекс активностей",
  "activities.fetching": "Завантаження активностей...",
  "activities.rateLimit": "Досягнуто ліміту запитів Strava; продовження о {time}",
  "activities.noData": "На жаль, даних немає &#128577;",
  "activities.colServerCache": "Трек у кеші на сервері (Mongo)",
  "activities.colBrowserCache": "Трек у кеші цього браузера",
  "activities.cachedServer": "Трек {id} є в кеші на сервері",
  "activities.notCachedServer": "Треку {id} немає в кеші на сервері",
  "activities.cachedBrowser": "Трек {id} є в кеші цього браузера",
  "activities.notCachedBrowser": "Треку {id} немає в кеші цього браузера",
  "sport.AlpineSki": "Гірські лижі",
  "sport.BackcountrySki": "Скітур",
  "sport.Badminton": "Бадмінтон",
  "sport.Basketball": "Баскетбол",
  "sport.Canoeing": "Каное",
  "sport.Cricket": "Крикет",
  "sport.Crossfit": "Кросфіт",
  "sport.Dance": "Танці",
  "sport.EBikeRide": "Заїзд на електровелосипеді",
  "sport.Elliptical": "Орбітрек",
  "sport.EMountainBikeRide": "Заїзд на електро-МТБ",
  "sport.Golf": "Гольф",
  "sport.GravelRide": "Гревел-заїзд",
  "sport.Handcycle": "Хендбайк",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Похід",
  "sport.IceSkate": "Ковзани",
  "sport.InlineSkate": "Ролики",
  "sport.Kayaking": "Каякінг",
  "sport.Kitesurf": "Кайтсерфінг",
  "sport.MountainBikeRide": "Заїзд на МТБ",
  "sport.NordicSki": "Бігові лижі",
  "sport.Padel": "Падел",
  "sport.PhysicalTherapy": "Фізіотерапія",
  "sport.Pickleball": "Пікбол",
  "sport.Pilates": "Пілатес",
  "sport.Racquetball": "Ракетбол",
  "sport.Ride": "Велозаїзд",
  "sport.RockClimbing": "Скелелазіння",
  "sport.RollerSki": "Лижоролери",
  "sport.Rowing": "Веслування",
  "sport.Run": "Біг",
  "sport.Sail": "Вітрильний спорт",
  "sport.Skateboard": "Скейтборд",
  "sport.Snowboard": "Сноуборд",
  "sport.Snowshoe": "Снігоступи",
  "sport.Soccer": "Футбол",
  "sport.Squash": "Сквош",
  "sport.StairStepper": "Степер",
  "sport.StandUpPaddling": "Сапбординг",
  "sport.Surfing": "Серфінг",
  "sport.Swim": "Плавання",
  "sport.TableTennis": "Настільний теніс",
  "sport.Tennis": "Теніс",
  "sport.TrailRun": "Трейлранінг",
  "sport.Velomobile": "Веломобіль",
  "sport.VirtualRide": "Віртуальний велозаїзд",
  "sport.VirtualRow": "Віртуальне веслування",
  "sport.VirtualRun": "Віртуальний біг",
  "sport.Volleyball": "Волейбол",
  "sport.Walk": "Ходьба",
  "sport.WeightTraining": "Силове тренування",
  "sport.Wheelchair": "Інвалідний візок",
  "sport.Windsurf": "Віндсерфінг",
  "sport.Workout": "Тренування",
  "sport.Yoga": "Йога"
}
